import { useCallback, useState } from 'react';

export function useScheduleLocationMode(params: { onOrganizeByLocation: () => Promise<void> | void }) {
  const { onOrganizeByLocation } = params;
  const [showAllLocations, setShowAllLocations] = useState(false);

  const handleShowAllLocationsChange = useCallback(
    async (nextShowAll: boolean) => {
      if (nextShowAll) {
        setShowAllLocations(true);
        return;
      }
      setShowAllLocations(false);
      await onOrganizeByLocation();
    },
    [onOrganizeByLocation],
  );

  return {
    showAllLocations,
    setShowAllLocations,
    handleShowAllLocationsChange,
  };
}

